import { cva } from "class-variance-authority";

export const checkboxV2Variants = cva(
  "peer shrink-0 border bg-white ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 flex items-center justify-center",
  {
    variants: {
      variant: {
        default:
          "data-[state=checked]:bg-[var(--color-ui-primary)] data-[state=checked]:border-[var(--color-ui-primary)] data-[state=checked]:text-white border-[#757575]",
        radio: "border-slate-400 data-[state=checked]:border-[#1e293b] data-[state=checked]:text-[#1e293b]",
      },
      size: {
        sm: "h-4 w-4",
        md: "h-5 w-5",
      },
      shape: {
        square: "rounded-[4px]",
        circle: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      shape: "square",
    },
  },
);

export const checkboxV2IconVariants = cva("", {
  variants: {
    size: {
      sm: "h-2 w-2",
      md: "h-2.5 w-2.5",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
